import {
  changeNotification,
  wsConnect, wsConnected, wsConnecting, wsDisconnect, wsDisconnected, wsError,
} from '../actions/websocket';
import { setWebsocketConnected, setWebsocketError } from '../slices/websocketSlice';
import { fetchJWT } from '../slices/jwtSlice';
import { NotificationMessageType } from '../../utility/types/NotificationMessageType';
import envConfig from '../../envConfig';
// No test because complexity
/* istanbul ignore file */
const socketMiddleware = () => {
  let socket = null;

  const onOpen = (store) => (event) => {
    store.dispatch(wsConnected(event.target.url));
  };

  const onClose = (store) => (event) => {
    if (event.code && event.code === 1000) {
      socket = null;
    }
    store.dispatch(wsDisconnected(event.code && event.code === 1008));
  };

  const onError = (store) => () => {
    store.dispatch(wsError());
  };

  const onMessage = (store) => (event) => {
    const payload = JSON.parse(event.data);
    store.dispatch(setWebsocketError(false));
    if (payload.t === NotificationMessageType.CRUD) {
      store.dispatch(changeNotification(payload.et, payload.ct, payload.i, payload.pt, payload.pi));
    }
  };

  return (store) => (next) => (action) => {
    switch (action.type) {
      case 'WS_CONNECT':
        if (socket !== null) {
          socket.close();
          socket = null;
        }
        socket = new WebSocket(`${action.host}${action.jwt === null ? '' : `/${action.jwt}`}`);
        socket.onmessage = onMessage(store);
        socket.onclose = onClose(store);
        socket.onopen = onOpen(store);
        socket.onerror = onError(store);
        store.dispatch(wsConnecting());
        break;
      case 'WS_CONNECTED':
        store.dispatch(setWebsocketConnected(true));
        break;
      case 'WS_ERROR':
        store.dispatch(wsDisconnect());
        store.dispatch(setWebsocketError(true));
        break;
      case 'WS_DISCONNECT':
        if (socket !== null) {
          socket.close();
        }
        break;
      case 'WS_DISCONNECTED':
        store.dispatch(setWebsocketConnected(false));
        socket = null;
        if (action.reAuthorize) {
          store.dispatch(fetchJWT());
        } else if (store.getState().websocket.autoRetry === true) {
          setTimeout(
            () => store
              .dispatch(wsConnect(envConfig.wsUrl, store.getState().jwt.token)),
            5000,
          );
        }
        break;
      default:
        return next(action);
    }
    return next(action);
  };
};

export default socketMiddleware();
